import { ServiceTemplateRecurrencePeriod } from "@common/types/serviceTemplateRecurrencePeriod";

export function getOccurrencePeriodCap(
    period: ServiceTemplateRecurrencePeriod,
    interval: number,
): number {
    switch (period) {
        case ServiceTemplateRecurrencePeriod.DAILY:
            return 1500;
        case ServiceTemplateRecurrencePeriod.WEEKLY:
            return interval >= 2 ? 1000 : 600;
        case ServiceTemplateRecurrencePeriod.MONTHLY:
            return 240;
        case ServiceTemplateRecurrencePeriod.QUARTERLY:
            return 120;
        case ServiceTemplateRecurrencePeriod.ANNUALLY:
            return 100;
    }
}
